import React, { Component } from "react";
import { ListingContext } from "../../Context";
import SkeletonText from "../../components/skeleton/SkeletonText";
import { GetRoomDimensions } from "../../utils/consts";

export default class ListingSizes extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          const rooms = listing.rooms || {};
          // console.log(rooms);

          if (listingContext.loading) {
            return (
              <div className="listing-sizes">
                <SkeletonText lines={5} />
              </div>
            );
          } else if (!!Object.keys(rooms).length) {
            return (
              <div className="listing-sizes">
                <h5 className="listing-section__title">Rooms</h5>
                <div className="listing-sizes__sizes">
                  {Object.keys(rooms)
                    .sort()
                    .map((room, i) => {
                      const dimensions = GetRoomDimensions(rooms[room]);
                      return (
                        <p key={`${room}-${i}`} className="listing-list__item">
                          {room}: {dimensions}
                        </p>
                      );
                    })}
                </div>
              </div>
            );
          }
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/listing/ListingSizes.js